module.exports = __webpack_public_path__ + "img/little-girl.70d4d2d0.png";